import request from '@/utils/request'

// 获取看板用户权限列表
export function getUserRoleList(data) {
  return request.post('/phalapi/public/?service=Kanban.Dep.GetUserRoleList', data)
}

// 获取部门列表
export function getDepartmentList(data) {
  return request.post('/phalapi/public/?service=Kanban.Dep.GetUserDepartmentList', data)
}

// 获取分组列表
export function getArticleGroupList(data) {
  return request.post('/phalapi/public/?service=Kanban.Group.GetGroupList', data)
}

// 保存分组列表
export function saveGroup(data) {
  return request.post('/phalapi/public/?service=Kanban.Group.saveGroup', data)
}

// 删除分组列表
export function delGroup(data) {
  return request.post('/phalapi/public/?service=Kanban.Group.delGroup', data)
}

// 分组排序
export function updateSortGroup(data) {
  return request.post('/phalapi/public/?service=Kanban.Group.UpdateSortGroup', data)
}

// 获取文章列表
export function getArticleList(data) {
  return request.post('/phalapi/public/?service=Kanban.Article.GetArticleList', data)
}

// 保存文章
export function saveArticle(data) {
  return request.post('/phalapi/public/?service=Kanban.Article.SaveArticle', data)
}

// 文章排序
export function sortArticle(data) {
  return request.post('/phalapi/public/?service=Kanban.Article.ChangeAndSortArticle', data)
}

// 文章删除
export function delArticle(data) {
  return request.post('/phalapi/public/?service=Kanban.Article.DelArticle', data)
}

// 文章详情
export function getArticleDetail(data) {
  return request.post('/phalapi/public/?service=Kanban.Article.GetArticleDetail', data)
}

// 部门人员树形结构
export function getDepartmentUserList(data) {
  return request.post('/phalapi/public/?service=Kanban.Dep.GetDepartmentUserList', data)
}

// 查询管理员列表
export function getSettingList(data) {
  return request.post('/phalapi/public/?service=Kanban.DepartmentAdmin.getSettingList', data)
}

// 保存系统设置信息
export function saveSettings(data) {
  return request.post('/phalapi/public/?service=Kanban.DepartmentAdmin.saveSettings', data)
}

// 获取评论列表
export function getCommentList(data) {
  return request.post('/phalapi/public/?service=Kanban.Comment.GetCommentList', data)
}

// 发表评论
export function saveComment(data) {
  return request.post('/phalapi/public/?service=Kanban.Comment.SaveComment', data)
}

// 删除评论
export function delComment(data) {
  return request.post('/phalapi/public/?service=Kanban.Comment.DelComment', data)
}

// 点赞和取消点赞
export function saveZan(data) {
  return request.post('/phalapi/public/?service=Kanban.Zan.SaveZan', data)
}

// 七牛上传视频信息
export function getQiniuConfig(data) {
  return request.post('/phalapi/public/?service=App.Common.GetQiniuConfig', data)
}

// 发送通知
export function updateArticlePushTime(data) {
  return request.post('/phalapi/public/?service=Kanban.Article.UpdateArticlePushTime', data)
}

// 设置文章全部已读
export function setAllMsgIsRead(data) {
  return request.post('/phalapi/public/?service=Kanban.Article.setAllMsgIsRead', data)
}

// 获得历史时刻事件列表
export function getEventListByType(data) {
  return request.post('/phalapi/public/?service=Kanban.Event.GetEventListByType', data)
}

// 保存历史时刻事件
export function saveEvent(data) {
  return request.post('/phalapi/public/?service=Kanban.Event.SaveEvent', data)
}

// 删除历史时刻事件
export function delEvent(data) {
  return request.post('/phalapi/public/?service=Kanban.Event.DelEvent', data)
}

// 获取欢迎弹窗内容
export function getBlessEvents(data) {
  return request.post('/phalapi/public/?service=Kanban.Pop.getBlessEvents', data)
}

// 获取祝福事件总表
export function getWelcomePopInfo(data) {
  return request.post('/phalapi/public/?service=Kanban.Pop.GetWelcomePopInfo', data)
}

// 转换条目类型
export function changeArticleType(data) {
  return request.post('/phalapi/public/?service=Kanban.Article.changeArticleType', data)
}

// 编辑条目注解
export function editAnnotate(data) {
  return request.post('/phalapi/public/?service=Kanban.Article.EditAnnotate', data)
}

// 移除条目注解
export function delAnnotate(data) {
  return request.post('/phalapi/public/?service=Kanban.Article.DelAnnotate', data)
}

// 获取访问量统计
export function getVisitLog(data) {
  return request.post('/phalapi/public/?service=Kanban.Dep.GetVisitLog', data)
}
// 获取互动表情列表
export function getInteractList(data) {
  return request.post('/phalapi/public/?service=Kanban.Article.getInteractList', data)
}

// 保存互动记录
export function saveInteract(data) {
  return request.post('/phalapi/public/?service=Kanban.Article.saveInteract', data)
}

// 获取注解列表
export function getAnnotateList(data) {
  return request.post('/phalapi/public/?service=Kanban.Article.getAnnotateList', data)
}

// 获取文章下的词条列表
export function getArticleAnnotateList(data) {
  return request.post('/phalapi/public/?service=Kanban.Article.getArticleAnnotateList', data)
}

// 获取看板条目信息
export function getArticleKanbanInfo(data) {
  return request.post('/phalapi/public/?service=Kanban.Dep.GetArticleKanbanInfo', data)
}

// 移动条目
export function moveArticle(data) {
  return request.post('/phalapi/public/?service=Kanban.Article.MoveArticle', data)
}

// 获得可以移动的树型结构
export function getMoveAbleTree(data) {
  return request.post('/phalapi/public/?service=Kanban.Group.GetMoveAbleTree', data)
}

// 获得用户相关的任务列表
export function getUserTaskList(data) {
  return request.post('/phalapi/public/?service=Kanban.Article.getUserTaskList', data)
}

// 获取自定义字段列表
export function getFieldList(data) {
  return request.post('/phalapi/public/?service=Kanban.Field.getFieldList', data)
}

// 自定义字段排序接口
export function sortField(data) {
  return request.post('/phalapi/public/?service=Kanban.Field.sortField', data)
}

// 自定义字段新增/编辑接口
export function editField(data) {
  return request.post('/phalapi/public/?service=Kanban.Field.editField', data)
}

// 自定义字段删除接口
export function deleteField(data) {
  return request.post('/phalapi/public/?service=Kanban.Field.deleteField', data)
}

// 编辑条目下的字段值
export function editArticleField(data) {
  return request.post('/phalapi/public/?service=Kanban.Field.editArticleField', data)
}

// 获取近100天考试
export function getNearExamApi(data) {
  return request.post('/phalapi/public/?service=App.Common.GetNearExam', data)
}
